<template>
    <div class="self-container">
        <div class="user-bg-congainer">
            <div class="avatar-box">
                <img
                    class="avatar-img"
                    :src="$config.QINIU_URL + userInfo.userImgPath"
                    v-if="userInfo.userImgPath"
                />
                <img
                    src="../../../public/images/user/self/default-avatar.png"
                    v-if="!userInfo.userImgPath"
                />
            </div>
            <div class="nick-name">
                <span v-if="userInfo.nickName">{{ userInfo.nickName }}</span>
                <span v-if="!userInfo.nickName"
                    >用户编号:{{ userInfo.userNumber }}</span
                >
            </div>
            <div class="user-fn-bar">
                <div class="shortcut-link">
                    <div class="shortcut-link-left">
                        <span>我的订单</span>
                    </div>
                    <div class="shortcut-link-right">
                        <span @click="gotoView('/user/order/list')"
                            >全部订单</span
                        >
                    </div>
                </div>
                <div class="order-status">
                    <ul class="order-status-list">
                        <li
                            class="stauts-item"
                            @click="gotoView('/user/order/list?index=1')"
                        >
                            <div class="status-item-icon">
                                <img
                                    src="../../../public/images/user/self/order-status-payment.png"
                                />
                            </div>
                            <div class="status-item-text">
                                <span>待付款</span>
                            </div>
                        </li>
                        <li
                            class="stauts-item"
                            @click="gotoView('/user/order/list?index=2')"
                        >
                            <div class="status-item-icon">
                                <img
                                    src="../../../public/images/user/self/order-status-audit.png"
                                />
                            </div>
                            <div class="status-item-text">
                                <span>待审核</span>
                            </div>
                        </li>
                        <li
                            class="stauts-item"
                            @click="gotoView('/user/order/list?index=3')"
                        >
                            <div class="status-item-icon">
                                <img
                                    src="../../../public/images/user/self/order-status-goods.png"
                                />
                            </div>
                            <div class="status-item-text">
                                <span>待发货</span>
                            </div>
                        </li>
                        <li
                            class="stauts-item"
                            @click="gotoView('/user/order/list?index=4')"
                        >
                            <div class="status-item-icon">
                                <img
                                    src="../../../public/images/user/self/order-status-take.png"
                                />
                            </div>
                            <div class="status-item-text">
                                <span>待收货</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="user-menu-container">
            <ul class="user-menu-list">
                <li class="meun-item" @click="gotoView('/user/wallet')">
                    <div class="meun-left wallet-icon">
                        <span>我的预付货款</span>
                    </div>
                    <div class="meun-right"></div>
                </li>
                <li class="meun-item" @click="gotoView('/user/invoice/info')">
                    <div class="meun-left invoice-icon">
                        <span>开票资料</span>
                    </div>
                    <div class="meun-right"></div>
                </li>
                <li class="meun-item" @click="gotoView('/user/coupon')">
                    <div class="meun-left coupon-icon">
                        <span>优惠券</span>
                    </div>
                    <div class="meun-right"></div>
                </li>
                <li class="meun-item" @click="gotoView('/user/qrcode')">
                    <div class="meun-left qrcode-icon">
                        <span>我的二维码</span>
                    </div>
                    <div class="meun-right"></div>
                </li>
                <li class="meun-item" @click="gotoView('/user/address')">
                    <div class="meun-left address-icon">
                        <span>收货地址</span>
                    </div>
                    <div class="meun-right"></div>
                </li>
                <li class="meun-item" @click="gotoView('/user/linkman')">
                    <div class="meun-left linkman-icon">
                        <span>下单联系人</span>
                    </div>
                    <div class="meun-right"></div>
                </li>
                <li class="meun-item" @click="gotoView('/user/returns/list')">
                    <div class="meun-left after-sale-icon">
                        <span>退货售后</span>
                    </div>
                    <div class="meun-right"></div>
                </li>
            </ul>
        </div>
        <div class="user-menu-container margin-t">
            <ul class="user-menu-list">
                <li class="meun-item" @click="gotoView('/user/setting')">
                    <div class="meun-left setting-icon">
                        <span>设置</span>
                    </div>
                    <div class="meun-right"></div>
                </li>
            </ul>
        </div>
        <foot-bar></foot-bar>
    </div>
</template>
<script>
import { setUserNumber } from "@/utils/auth";
import FootBar from "@/components/FootBar";
export default {
    name: "SelfPage",
    components: {
        FootBar,
    },
    data() {
        return {
            userInfo: {},
            isEnd: false,
        };
    },
    beforeMount() {
        this.getUserInfo();
    },
    methods: {
        /**
         * @description 跳转页面
         */
        gotoView(path) {
            if (!path) return;
            if (!this.isEnd) return;
            this.$router.push({
                path: path,
            });
        },
        /**
         * @description 获取用户信息
         */
        getUserInfo() {
            let _this = this;
            let defaultInfo = {
                userNumber: "001",
            };
            this.$axios.post(this.$api.userApi.getUserInfo).then((response) => {
                let userInfo = response.data || defaultInfo;
                _this.userInfo = userInfo;
                _this.isEnd = true;
                setUserNumber(userInfo.userNumber);
            });
        },
    },
};
</script>
<style lang="less" scoped>
.self-container {
    padding-bottom: 110px;
}
.user-bg-congainer {
    position: relative;
    z-index: 1;
    width: 750px;
    height: 350px;
    background-image: url("../../../public/images/user/self/user-bg.png");
    background-size: 750px 350px;
    background-repeat: no-repeat;
    .avatar-box {
        overflow: hidden;
        position: absolute;
        z-index: 10;
        top: 64px;
        left: 80px;
        width: 110px;
        height: 110px;
        border-radius: 50%;
        background-color: #fff;
        img {
            width: 110px;
        }
    }
    .nick-name {
        overflow: hidden;
        white-space: nowrap;
        padding: 100px 230px 0;
        height: 50px;
        font-size: 36px;
        line-height: 36px;
        color: #fff;
        text-overflow: ellipsis;
    }
    .user-fn-bar {
        position: absolute;
        z-index: 20;
        padding: 0 40px;
        width: 630px;
        height: 220px;
        left: 50%;
        margin-left: -355px;
        bottom: -105px;
        background-color: #fff;
        border-radius: 15px;
        .shortcut-link {
            height: 79px;
            border-bottom: 1px solid #f2f2f2;
            .shortcut-link-left,
            .shortcut-link-right {
                height: 79px;
                font-size: 28px;
                line-height: 79px;
                color: #333;
            }
            .shortcut-link-left {
                width: 315px;
                float: left;
            }
            .shortcut-link-right {
                float: right;
                padding-right: 40px;
                width: 275px;
                background-image: url("../../../public/images/common/arrow-right-icon.png");
                background-position: center right;
                background-repeat: no-repeat;
                background-size: 40px;
                font-size: 24px;
                text-align: right;
                color: #666;
            }
        }
        .order-status {
            height: 140px;
            width: 630px;
            .order-status-list {
                height: 140px;
                width: 630px;
                .stauts-item {
                    float: left;
                    padding-top: 15px;
                    width: 25%;
                    height: 100px;
                    .status-item-icon {
                        margin: 0 auto;
                        width: 56px;
                        height: 56px;
                        img {
                            width: 56px;
                        }
                    }
                    .status-item-text {
                        padding-top: 7px;
                        height: 44px;
                        font-size: 24px;
                        line-height: 44px;
                        text-align: center;
                        color: #666;
                    }
                }
            }
        }
    }
}

.user-menu-container {
    margin: 130px auto 0;
    width: 710px;
    background-color: #fff;
    border-radius: 15px;
    &.margin-t {
        margin: 20px auto 0;
    }
    .user-menu-list {
        margin: 0 auto;
        width: 630px;
        > .meun-item {
            overflow: hidden;
            height: 110px;
            width: 630px;
            border-bottom: 1px solid #f2f2f2;
            .li-space {
                width: 710px;
                height: 15px;
                background-color: #333;
            }
            .meun-left {
                padding-left: 65px;
                float: left;
                width: 250px;
                height: 115px;
                background-size: 48px;
                background-repeat: no-repeat;
                background-position: left center;
                font-size: 28px;
                line-height: 115px;
                color: #333;
                &.invoice-icon {
                    background-image: url("../../../public/images/user/self/invoice-icon.png");
                }
                &.coupon-icon {
                    background-image: url("../../../public/images/user/self/coupon-icon.png");
                }
                &.qrcode-icon {
                    background-image: url("../../../public/images/user/self/qrcode-icon.png");
                }
                &.address-icon {
                    background-image: url("../../../public/images/user/self/address-icon.png");
                }
                &.linkman-icon {
                    background-image: url("../../../public/images/user/self/linkman-icon.png");
                }
                &.after-sale-icon {
                    background-image: url("../../../public/images/user/self/after-sale-icon.png");
                }
                &.setting-icon {
                    background-image: url("../../../public/images/user/self/setting-icon.png");
                }
                &.wallet-icon {
                    background-image: url("../../../public/images/user/self/wallet-icon.png");
                }
            }
            .meun-right {
                float: right;
                padding-right: 40px;
                width: 275px;
                height: 110px;
                background-image: url("../../../public/images/common/arrow-right-icon.png");
                background-position: center right;
                background-repeat: no-repeat;
                background-size: 40px;
                font-size: 24px;
                text-align: right;
                color: #666;
            }
        }
    }
}
</style>
